var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 6.99992C15 6.08325 15.75 5.33325 16.6667 5.33325V1.99992C16.6667 1.08325 15.9167 0.333252 15 0.333252H1.66667C0.75 0.333252 0.00833333 1.08325 0.00833333 1.99992V5.33325C0.925 5.33325 1.66667 6.08325 1.66667 6.99992C1.66667 7.91658 0.925 8.66658 0 8.66658V11.9999C0 12.9166 0.75 13.6666 1.66667 13.6666H15C15.9167 13.6666 16.6667 12.9166 16.6667 11.9999V8.66658C15.75 8.66658 15 7.91658 15 6.99992ZM11.3167 10.9999L8.33333 9.08325L5.35 10.9999L6.25 7.56659L3.50833 5.32492L7.04167 5.11658L8.33333 1.83325L9.61667 5.12492L13.15 5.33325L10.4083 7.57492L11.3167 10.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowtime);
export default __webpack_public_path__ + "static/media/showtime.c9abd530c412ea9c527fda4293d783a0.svg";
export { ForwardRef as ReactComponent };